import { F as o } from "./chunk-FormElement-DsGY7n6Z.js";
import { d as p, O as c } from "./chunk-debounce-Bk6yKvzA.js";
import { L as m } from "./chunk-LiveRegionUtility-1y3Y1dra.js";
import { W as d } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { t as y } from "./chunk-custom-element-CN0MC8o7.js";
import { n as a } from "./chunk-property---aaewZr.js";
var b = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, h = (t, i, e, n) => {
  for (var s = n > 1 ? void 0 : n ? _(i, e) : i, r = t.length - 1, l; r >= 0; r--)
    (l = t[r]) && (s = (n ? l(i, e, s) : l(s)) || s);
  return n && s && b(i, e, s), s;
};
let u = class extends d(o) {
  constructor() {
    super(), this.$liveRegionUtility = new m(this), this.changeEvent = new Event("change", { bubbles: !0 }), this.min = 0, this.max = 1 / 0, this._handleClick = this._handleClick.bind(this), this._handleChange = this._handleChange.bind(this), this._handleInput = this._handleInput.bind(this), this._handleDebounceChange = p(
      this._handleChange,
      c
    );
  }
  createRenderRoot() {
    return this;
  }
  _cacheElementSelectors() {
    this._input = this.querySelector("input"), this._buttonMinus = this.querySelector('[name="minus"]'), this._buttonPlus = this.querySelector('[name="plus"]');
  }
  get input() {
    return this._input;
  }
  get buttonMinus() {
    return this._buttonMinus;
  }
  get buttonPlus() {
    return this._buttonPlus;
  }
  setMinimumQuantity() {
    this.inputValue < this.min && (this.inputValue = this.min === 0 ? 1 : this.min);
  }
  async _handleChange() {
    if (this.validateQtyRules(), this.setMinimumQuantity(), !this.shopifyCartLoading && (this.value = this.inputValue, this.lineItemKey))
      try {
        await this.updateQuantityToCart({
          [this.lineItemKey]: this.inputValue
        });
      } catch {
        this.$liveRegionUtility.announce({
          message: "Failed to update quantity."
        }), this.resetValue(), this.inputValue = this.value;
      }
  }
  _handleInput() {
    this.validateQtyRules();
  }
  validateQtyRules() {
    var i, e;
    const t = this.inputValue;
    typeof this.min == "number" && ((i = this.buttonMinus) == null || i.toggleAttribute("disabled", t <= this.min)), this.max && ((e = this.buttonPlus) == null || e.toggleAttribute("disabled", t >= this.max));
  }
  connectedCallback() {
    super.connectedCallback(), this._cacheElementSelectors(), this.validateQtyRules(), this.addEventListener("click", this._handleClick), this.addEventListener("input", this._handleInput), this.addEventListener("change", this._handleDebounceChange);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick), this.removeEventListener("input", this._handleInput), this.removeEventListener("change", this._handleDebounceChange);
  }
  get inputValue() {
    return parseInt(this.input.value);
  }
  set inputValue(t) {
    this.input.value = String(t);
  }
  _handleClick(t) {
    if (t.preventDefault(), this.shopifyCartLoading) return;
    const i = t.target;
    if (!i) return;
    const e = i.tagName === "BUTTON" ? i : i.closest("button");
    if (!e) return;
    const n = this.inputValue;
    e === this.buttonPlus && (this.min > parseInt(this.input.step) && this.inputValue == 0 ? this.inputValue = this.min : this.input.stepUp()), e === this.buttonMinus && (this.inputValue < this.min ? this.inputValue = this.min : this.input.stepDown()), n !== this.inputValue && this.input.dispatchEvent(this.changeEvent), this.min === n && t.target === this.buttonMinus && (this.inputValue = this.min);
  }
};
h([
  a({ type: Number })
], u.prototype, "min", 2);
h([
  a({ type: Number })
], u.prototype, "max", 2);
h([
  a({ type: Number })
], u.prototype, "variantId", 2);
h([
  a({ type: Number, attribute: "cart-quantity" })
], u.prototype, "quantityInCart", 2);
h([
  a({ type: String, attribute: "key" })
], u.prototype, "lineItemKey", 2);
u = h([
  y("quantity-input")
], u);
